"use client";

import { ArrowLeft, Info } from "lucide-react";
import Footer from "@/components/Footer";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import SEO from "@/components/SEO";
import { AboutRoles } from "@/components/tools/leadership/AboutRoles";
import { useLanguage } from "@/context/LanguageContext";

export default function AboutPage() {
    const { t } = useLanguage();

    return (
        <div className="min-h-screen">
            <SEO
                title={t("seo.leadership.about.title")}
                description={t("seo.leadership.about.description")}
                keywords={t("seo.leadership.about.keywords").split(",").map(k => k.trim())}
            />
            <main id="main-content" className="container mx-auto px-4 py-12">
                <Link to="/tools/leadership_roles">
                    <Button variant="ghost" className="mb-8">
                        <ArrowLeft className="mr-2 h-4 w-4" />
                        Back to Leadership Roles
                    </Button>
                </Link>

                <div className="max-w-4xl mx-auto">
                    <div className="flex items-center gap-4 mb-8">
                        <div className="p-3 bg-primary/10 rounded-xl">
                            <Info className="h-8 w-8 text-primary" />
                        </div>
                        <h1 className="text-4xl font-bold">What this tool is about</h1>
                    </div>

                    <div className="bg-card border rounded-xl p-8 shadow-sm">
                        <AboutRoles />
                    </div>
                </div>
            </main>
            <Footer />
        </div>
    );
}
